import { Grid, useAutocomplete, Tabs, Tab } from "@pankod/refine-mui";

import CustomTabPanel from "components/CustomTabPanel";
import useTabs from "hooks/useTabs";
import useMySelect from "hooks/useMySelect";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import { useEffect } from "react";
import { useParams } from "@pankod/refine-react-router-v6";
import { useOne } from "@pankod/refine-core";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const [tabValue, handleChange, defProps] = useTabs(0);

  //solo per il campo gps ricarico i dati dal locale en (default)
  const { id } = useParams();
  const { data } = useOne({
    resource: "strutture",
    id,
    metaData: {
      locale: "en",
      fields: ["gps"],
      populate: ["gps"],
    },
  });
  useEffect(() => {
    setValue("gps.lat", data?.data?.gps?.lat);
    setValue("gps.lng", data?.data?.gps?.lng);
    console.log(data?.data?.gps);
  }, [getValues("gps")]);

  useEffect(() => {
    register("stars");
  }, []);
  useEffect(() => {
    const stars = (getValues("facility_category")?.name || "").slice(0, 1);
    setValue("stars", stars != "N" ? stars : 0);
  }, [getValues("facility_category")]);

  const { autocompleteProps: typeAC } = useAutocomplete({
    resource: "facility-types",
    pagination: {
      pageSize: 100,
    },
    metaData: {
      populate: "deep,2",
      // fields: ["id", "name"],
      // populate: {
      //   localizations: {
      //     fields: ["id", "name", "locale"],
      //   },
      // },
    },
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value,
      },
    ],
  });

  /*const categoryAC = [
    { label: "Non applicabile", value: 0 },
    { label: "1 stella", value: 1 },
    { label: "2 stelle", value: 2 },
    { label: "3 stelle", value: 3 },
    { label: "4 stelle", value: 4 },
    { label: "5 stelle", value: 5 },
  ];*/

  const { autocompleteProps: categoryAC } = useAutocomplete({
    resource: "facility-categories",
    metaData: {
      populate: "deep,2",
      // fields: ["id", "name"],
      // populate: {
      //   localizations: {
      //     fields: ["id", "name", "locale"],
      //   },
      // },
    },
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value,
      },
    ],
  });

  const { autocompleteProps: usersAC } = useAutocomplete({
    resource: "users",
    pagination: {
      pageSize: 999,
    },
    metaData: {
      fields: ["email", "id"],
    },
    filters: [
      {
        field: "role.type",
        operator: "eq",
        value: "owner",
      },
    ],
    onSearch: (value) => [
      {
        field: "email",
        operator: "contains",
        value,
      },
    ],
  });

  /*const { options: servicesAC } = useSelect({
    resource: "facility-services",
    optionLabel: "name", // -> servicesAC.label
    optionValue: "id", // -> servicesAC.value
  });*/
  const servicesAC = useMySelect({
    resource: "facility-services",
    config: {
      pagination: {
        pageSize: 999,
      },
    },
    metaData: {
      fields: ["id", "name"],
      populate: {
        localizations: {
          fields: ["id", "name", "locale"],
        },
        facility_service_type: {
          fields: ["id", "name"],
          populate: {
            localizations: {
              fields: ["id", "name", "locale"],
            },
          },
        },
      },
    },
    optionLabel: "name", // -> servicesAC.label
    optionValue: "id", // -> servicesAC.value
    optionType: { type: "facility_service_type", accessor: "name" }, // -> servicesAC.type
    //optionType: { type: "facility_service_type" }, // se la categoria non è un campo nested
  });

  const fieldsGeneral = [
    {
      label: "Nome",
      name: "businessName",
      required: true,
      type: "text",
    },
    {
      label: "Tipologia",
      name: "facility_type",
      accessor: "name",
      options: typeAC,
      required: true,
      type: "autocomplete",
    },
    {
      label: "Categoria/stelle",
      name: "facility_category",
      accessor: "name",
      options: categoryAC,
      required: true,
      type: "autocomplete",
    },
    /*{
      label: "Categoria/stelle",
      name: "stars",
      options: categoryAC,
      required: true,
      type: "select",
    },*/
    {
      label: "Prenotabile solo contattando la struttura",
      name: "request_only",
      type: "switch",
    },
    {
      label: "Descrizione",
      name: "description",
      required: true,
      type: "text",
      lines: 4,
      localized: true,
    },
    {
      label: "Numero camere",
      name: "rooms",
      required: true,
      type: "number",
    },
    {
      label: "Proprietario",
      name: "owner",
      accessor: "email", //al momento metto questa, poi andrà sostituita con Nome+Cognome
      options: usersAC,
      required: true,
      type: "autocomplete",
    },
    { type: "divider" },
    {
      label: "Indirizzo",
      name: "address",
      required: true,
      type: "text",
    },
    {
      label: "Città",
      name: "city",
      required: true,
      type: "text",
    },
    {
      label: "CAP",
      name: "zip",
      required: true,
      type: "text",
    },
    {
      label: "Provincia",
      name: "province",
      required: true,
      type: "text",
    },
    {
      label: "Stato",
      name: "country",
      required: true,
      type: "text",
    },
    {
      label: "Latitudine",
      name: "gps.lat", //"latitude",
      required: true,
      type: "text",
      md: 6,
    },
    {
      label: "Longitudine",
      name: "gps.lng", //longitude",
      required: true,
      type: "text",
      md: 6,
    },
    { type: "divider" },
    {
      type: "title",
      variant: "h6",
      label: "Contatti",
    },
    {
      label: "Email",
      name: "representativeEmail",
      required: true,
      type: "text",
    },
    {
      label: "Telefono",
      name: "businessPhoneNumber",
      required: true,
      type: "text",
    },
    {
      label: "Sito web",
      name: "webURL",
      required: true,
      type: "text",
    },
  ];

  const fieldsInfo = [
    {
      type: "title",
      variant: "h6",
      label: "Check-in e Check-out",
    },
    {
      label: "Arrivo",
      name: "checkinTime",
      required: false,
      defaultValue: "00:00:00.000",
      type: "time",
      md: 6,
    },
    {
      label: "Partenza",
      name: "checkoutTime",
      required: false,
      defaultValue: "00:00:00.000",
      type: "time",
      md: 6,
    },
    {
      type: "title",
      variant: "h6",
      label: "Altre informazioni",
    },
    {
      label: "Età massima del minore per accedere a sconto",
      name: "children_age",
      required: false,
      type: "number",
      inputProps: { max: 17, min: 0 },
      validation: {
        range: (value) => {
          if (parseInt(value) > 17 || parseInt(value) < 0) {
            return "L'età dev'essere compresa tra 0 e 17 anni";
          }
        },
      },
    },
    {
      label: "Maggiori informazioni",
      name: "additionalInfo",
      required: false,
      type: "text",
      lines: 4,
      localized: true,
    },
  ];

  const fieldsServices = [
    {
      label: "Servizi",
      name: "facility_services",
      required: true,
      type: "multi-select-checkbox",
      options: servicesAC,
    },
  ];

  const fieldsMedia = [
    {
      type: "title",
      variant: "h6",
      label: "Immagine principale",
    },
    {
      label: "Immagine principale",
      name: "image",
      required: true,
      type: "image",
    },
    {
      type: "title",
      variant: "h6",
      label: "Galleria foto",
    },
    {
      label: "Galleria foto",
      name: "gallery",
      required: false,
      type: "gallery",
    },
  ];

  const fieldsBilling = [
    {
      label: "Nome",
      name: "billing_businessName",
      required: true,
      type: "text",
    },
    {
      label: "Ragione sociale",
      name: "ragioneSociale",
      required: true,
      type: "text",
    },
    {
      label: "Rappresentante legale",
      name: "representativeName",
      required: true,
      type: "text",
    },
    {
      label: "Partita IVA",
      name: "partitaIVA",
      required: true,
      type: "text",
    },
    {
      label: "Codice univoco",
      name: "codiceUnivoco",
      required: true,
      type: "text",
    },
    { type: "divider" },
    {
      label: "Indirizzo",
      name: "billing_address",
      required: true,
      type: "text",
    },
    {
      label: "Città",
      name: "billing_city",
      required: true,
      type: "text",
    },
    {
      label: "CAP",
      name: "billing_zip",
      required: true,
      type: "text",
    },
    {
      label: "Provincia",
      name: "billing_region",
      required: true,
      type: "text",
    },
    {
      label: "Stato",
      name: "billing_country",
      required: true,
      type: "text",
    },
  ];

  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        //aria-label="basic tabs example"
      >
        <Tab label="Dati struttura" {...defProps(0)} />
        <Tab label="Info utili" {...defProps(1)} />
        <Tab label="Servizi" {...defProps(2)} />
        <Tab label="Immagini" {...defProps(3)} />
        <Tab label="Dati aziendali" {...defProps(4)} />
      </Tabs>

      <CustomTabPanel value={tabValue} index={0}>
        <Grid container spacing={2}>
          {fieldsGeneral.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value={tabValue} index={1}>
        <Grid container spacing={2}>
          {fieldsInfo.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <Grid container spacing={2}>
          {fieldsServices.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={3}>
        <Grid container spacing={2}>
          {fieldsMedia.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={4}>
        <Grid container spacing={2}>
          {fieldsBilling.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                disabled={disabled}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
    </div>
  );
}
